/**
 * exportExcel — client-side .xlsx export via SheetJS (P1.1).
 *
 * No backend endpoint: the table's visible rows are serialised in the browser
 * and downloaded as a real .xlsx workbook. Each sheet is a list of flat row
 * objects (column header = object key; insertion order preserved).
 *
 * UX-J2: provider brands must NOT leak into user-facing UI — callers pass
 * already-flattened, user-facing column values (no provider/model names).
 */
import * as XLSX from 'xlsx';

export interface ExcelSheet {
  /** Sheet tab name (Excel caps at 31 chars). */
  name: string;
  /** Flat rows: each key becomes a column. */
  rows: Record<string, unknown>[];
}

/**
 * Build an .xlsx workbook from the given sheets and trigger a browser
 * download. Sheets with no rows are skipped (empty tabs add no value).
 */
export function exportSheetsToExcel(filename: string, sheets: ExcelSheet[]): void {
  const nonEmpty = sheets.filter((s) => s.rows.length > 0);
  if (nonEmpty.length === 0) return;
  const wb = XLSX.utils.book_new();
  for (const sheet of nonEmpty) {
    const ws = XLSX.utils.json_to_sheet(sheet.rows);
    XLSX.utils.book_append_sheet(wb, ws, sheet.name.slice(0, 31) || 'Sheet1');
  }
  const name = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
  XLSX.writeFile(wb, name);
}